import React from 'react'

import useGame from 'utils/hooks/queries/games/useGame'

import Game from '../../components/Game'
import GameBoxFallback from './Fallback'
import { GameBoxProps } from './types'

function GameBoxWithData({ slug, size }: GameBoxProps) {
  const { data: game, isPending } = useGame({ slug })

  if (isPending || !game) {
    return <GameBoxFallback />
  }

  return (
    <Game
      game={game}
      size={size}
    />
  )
}

export default GameBoxWithData
